module.exports = __webpack_public_path__ + "static/fonts/Fact-CondensedMedium.96bf72f.woff";